import React, { useState } from 'react'
import { Carousel } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const heroSlides = [
  {
    image: "/img/lunbotu/1.png",
    mobileImage: "/img/lunbotu-2/b1.png",
    alt: "Get Quotes banner",
    link: "/products",
  },
  {
    image: "/img/lunbotu/2.png",
    mobileImage: "/img/lunbotu-2/b2.png",
    alt: "Expert Product Development Assistance banner",
    link: "/odm_services",
  },
  {
    image: "/img/lunbotu/3.png",
    mobileImage: "/img/lunbotu-2/b3.png",
    alt: "Prototypes Quality Control banner",
    link: "/contact_us",
  },
  {
    image: "/img/lunbotu/4.png",
    mobileImage: "/img/lunbotu-2/b4.png",
    alt: "Can't Find a Part banner",
    link: "/contact_us",
  },
  {
    image: "/img/lunbotu/5.png",
    mobileImage: "/img/lunbotu-2/b5.png",
    alt: "PCB Instant Quote banner",
    link: "/get_quote",
  },
];

/**
 * 渲染首页顶部轮播图。
 */
const Hero = () => {
  const [index, setIndex] = useState(0);

  /**
   * 切换当前轮播图索引。
   */
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <section className="hero-section home-hero-carousel">
      <div className="text-area">
        <div id="hero_section_carousel_container">
          <div
            id="hero_section_text_slider carousel-indicators"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <Carousel
              className="carousel-inner carousel-dark"
              indicators={true}
              controls={false}
              activeIndex={index}
              onSelect={handleSelect}
            >
              {heroSlides.map((slide) => (
                <Carousel.Item className="carousel-item" key={slide.image}>
                  <Link className="home-hero-slide-link" to={slide.link}>
                    <picture>
                      <source media="(max-width: 767px)" srcSet={slide.mobileImage} />
                      <img src={slide.image} alt={slide.alt} />
                    </picture>
                  </Link>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero
